import UtilUnity from "@/app/(game)/unity-game/UtilUnity";
import ChannelMgr from "@/Fwk/Channel/ChannelMgr";
import KitPwa from "@/Master/PWA/KitPwa";
import KitAPI from "@/Fwk/Kit/KitAPI";
import domain2 from "@/app/config/domain/gogogoldwin";
import domain1 from "@/app/config/domain/domain_1";

export default class MainScene {
    static onInit() {
        //初始化Adjust 归因
        ChannelMgr.Init();

        // //初始化SDK
        KitAPI.Init(JSON.stringify(domain2), JSON.stringify(domain1));

        //PWA初始化
        KitPwa.Init();

        MainScene.onEnter();
    }

    static onEnter() {
        // DuMgr.Init();
        UtilUnity.Init()
    }

    static onUpdate() {



    }

    static onDestroy() {
    }


}
